import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Layout } from "../pages/landing/Layout";
import { Loader } from "../components/Loader";
import { SellFaq } from "../sections/SellFaq";
import { CallToAction } from "../sections/CallToAction";
import { LinkedinHeadshotHow } from "../sections/linkedin_headshot/LinkedinHeadshotHow";
import { PatternDiscover } from "../sections/pattern/PatternDiscover";
import { LinkedinHeadshotBanner } from "../sections/linkedin_headshot/LinkedinHeadshotBanner";
import { FeatureImageRight } from "../sections/FeatureImageRight";
import { FeatureImageLeft } from "../sections/FeatureImageLeft";

export const linkedin_headshot_generator_faq_data = [
    {
        question:
            "Can I use my AI headshot for other professional profiles like resumes?",
        answer: "Absolutely! Your AI-generated profile photo is suitable for business applications including resumes, company websites, business cards, and professional platforms.",
    },
    {
        question: "Can I use the LinkedIn headshot generator for my team?",
        answer: "Yes, you can use the LinkedIn headshot generator for your team. You can upload your team's photo and our LinkedIn headshot generator will generate a professional-looking headshot for each team member.",
    },
    {
        question: "Who owns the generated headshot photos?",
        answer: "You own the generated LinkedIn headshot photos. You have full ownership over your photos.",
    },
    {
        question: "What about privacy? Are my headshot photos safe?",
        answer: "Yes, your images are safe with us. Patternful.ai prioritizes user data safety. Your images are always private, proprietary, and they remain your property. All your uploaded images are automatically deleted from our servers after a few hours.",
    },
];

class LinkedinHeadshotLanding extends Component {
    constructor(props) {
        super(props);
        this.state = { isLoading: true };
    }
    componentDidMount() {
        this.setState({ isLoading: false });
    }

    render() {
        if (this.state.isLoading) {
            return <Loader />;
        }
        return (
            <Layout>
                <Helmet>
                    <title>Linkedin Headshot Generator</title>
                    <meta
                        name="description"
                        content="Generate professional LinkedIn headshots in various styles."
                    />
                    <meta
                        name="keywords"
                        content="Linkedin Headshot Generator, AI LinkedIn Headshot Generator, LinkedIn Headshot Generator APP, LinkedIn Headshot Online Generator, Image Processing, AI Image Editing, Patternful, Patternful AI"
                    />
                </Helmet>
                <LinkedinHeadshotBanner />
                <LinkedinHeadshotHow />
                <FeatureImageLeft
                    image={"/images/linkedin-headshot/Feature-1.webp"}
                    title={"Professional Headshots - No Studio Needed"}
                    description={
                        "Creating a professional LinkedIn profile requires a proper headshot which studio photography costs both time and money yet produces good results. Using the AI LinkedIn headshot generator from Patternful you can achieve professional-quality pictures in an instant at no cost to studio sessions. The tool allows users to upload one photo which then AI optimizes lighting and composition before generating studio-level output in an instant fashion."
                    }
                />
                <FeatureImageRight
                    image={"/images/linkedin-headshot/Feature-2.webp"}
                    title={"Elevate Your LinkedIn Presence with AI"}
                    description={
                        "A low-quality or outdated LinkedIn profile picture delivers a negative impression which affects your professional public image before people interact with your profile content. Patternful offers a LinkedIn photo generator that allows you to achieve an instant online profile transformation. Your professional development requires a top-notch photo that should be used whenever you connect with others as part of your career activities."
                    }
                />

                <CallToAction
                    title={"Upload to Generate LinkedIn Headshots"}
                    subtitle={
                        "It has never been this easy to generate professional LinkedIn headshots! Simply upload your photo and let our LinkedIn headshot generator do the work. "
                    }
                    link={"/linkedin-headshot/app"}
                    cta={"Get Started Now"}
                />
                <SellFaq data={linkedin_headshot_generator_faq_data} />
                <PatternDiscover />
            </Layout>
        );
    }
}

function mapStateToProps(state) {
    return { userAccount: state.authReducer?.userAuth.userAccount };
}

export default connect(
    mapStateToProps,
    {}
)(withRouter(LinkedinHeadshotLanding));
